export default __webpack_public_path__ + "static/media/Arte_de_brincar.f424bb56.jpg";